import React from "react";
import classNames from "classnames";
import { trackProgressBar } from "../../utils/tracking/tracking";

const ProgressNavigationStep = ({
    flowIndex,
    steps,
    index,
    goTo,
    title,
    disabled,
    isPreviousToDisabled,
    values,
}) => {
    const mainStepIndex = steps.findIndex(
        (step) => step.NavigationStepIndex === index
    );

    const visited = !!steps[index];

    const classes = classNames("progress-navigation-item", {
        "progress-navigation-item--previous-disabled": isPreviousToDisabled,
        "progress-navigation-item--disabled": disabled,
        "progress-navigation-item--active": index === flowIndex,
        "progress-navigation-item--previous": index < flowIndex && !disabled,
        "progress-navigation-item--visited":
            visited && mainStepIndex > flowIndex,
    });

    return (
        <li className={classes}>
            <button
                type="button"
                className="progress-navigation-item__button"
                onClick={() => {
                    trackProgressBar(title);
                    goTo(mainStepIndex, values);
                }}
                disabled={!visited && mainStepIndex > flowIndex}
                aria-label={title}
            >
                <span className="progress-navigation-item__circle">
                    {index + 1}
                </span>
                <span className="progress-navigation-item__text">{title}</span>
            </button>
        </li>
    );
};

export default ProgressNavigationStep;
